module.exports = __webpack_public_path__ + "img/environments_intro.75b748ff.svg";